import React from 'react';
import { Modal, Box, Typography } from '@mui/material';
import { Firm } from 'types/types';
import FirmForm from 'components/FirmForm/FirmForm';
import FigmaModal from 'components/modal/FigmaModal';

interface EditFirmModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  firm: Firm & { id: string };
}

const EditFirmModal: React.FC<EditFirmModalProps> = ({ open, onClose, onSuccess, firm }) => {
  const handleSuccess = () => {
    onSuccess();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        paddingTop: "16px"
      }}>
        <Typography variant="h6" noWrap component="div" fontFamily={'Helvetica Neue LT Std'} fontWeight={'300'} fontSize={28} color={'#1A1A1A'}>
          Edit Firm
        </Typography>
        <FirmForm
          initialData={firm}
          onSuccess={handleSuccess}
          onClose={onClose}
        />
      </Box>
    </Modal>
  );
};

export default EditFirmModal;